import { FC, PropsWithChildren } from 'react';

import { clientConfig } from '@/config/clientConfig';

import { AppContainerCloud } from './AppContainerCloud';
import { AppContainerExported } from './AppContainerExported';

export const AppContainer: FC<PropsWithChildren> = ({ children }) => {
  const Container = !clientConfig.isExported ? AppContainerCloud : AppContainerExported;

  return <Container>{children}</Container>;
};
